<h2 class="font-heading-3 ms-large-b">
  {{ 'MMB.carRentalTab.mainTitle' | finLocalization }}
</h2>

<fin-cartrawler-widget [order]="order$ | async" [clientId]="clientId"></fin-cartrawler-widget>

<fin-cartrawler-airport-transfers
  *ngIf="airportTransfersImage$ | async"
  [order$]="order$"
  [cmsImage]="airportTransfersImage$ | async"
></fin-cartrawler-airport-transfers>
